import React, { useState } from 'react';
import { ReactComponent as InfoIcon } from '@/assets/icons/info.svg';
import ExplanatoryModal from '@/components/molecules/ExplanatoryModal';
import InvoiceExpanatoryImg1 from '@/assets/images/invoice-explanatory-1.png';
import InvoiceExpanatoryImg2 from '@/assets/images/invoice-explanatory-2.png';
import InvoiceExpanatoryImg3 from '@/assets/images/invoice-explanatory-3.png';
import InvoiceExpanatoryImg4 from '@/assets/images/invoice-explanatory-4.png';

const steps = [
  {
    title: 'Invoice vs Commitment',
    message:
      'Invoice is a finalized record of a financial transaction. While Commitment is a planned transaction that has not yet been paid.',
    img: InvoiceExpanatoryImg1
  },
  {
    title: 'Details to Include in an Invoice',
    message:
      'Each invoice includes key details such as The invoicing company and invoiced company, Invoice type (expense or revenue), Payment information, issue date, payment date, and payment terms.',
    img: InvoiceExpanatoryImg2
  },
  {
    title: 'How to Allocate an Invoice',
    message: 'Invoices must be allocated to a bank account, ACs, and EC/RCs based on their type for accurate tracking.',
    img: InvoiceExpanatoryImg3
  },
  {
    title: 'Tagging Invoices for Easy Search',
    message: 'Add tags to invoices for easier searching and categorization later.',
    img: InvoiceExpanatoryImg4
  }
];

const CreateInvoiceHeader: React.FC<{ title: string }> = ({ title }) => {
  const [isExplanatoryOpen, setIsExplanatoryOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <>
      <header className="flex  items-center justify-center md:justify-between">
        <h1 className="text-base md:text-2xl font-semibold">{title}</h1>
        <button
          type="button"
          title="Info"
          onClick={() => {
            setCurrentStep(0);
            setIsExplanatoryOpen(true);
          }}
          className="hidden md:block"
        >
          <InfoIcon />
        </button>
      </header>

      {/* Explanatory Modal */}
      {isExplanatoryOpen && (
        <ExplanatoryModal
          isOpen={isExplanatoryOpen}
          steps={steps}
          currentStep={currentStep}
          buttonText="Next"
          onButtonClick={() => {
            setCurrentStep(currentStep + 1);
          }}
          onClose={() => {
            setIsExplanatoryOpen(false);
          }}
          onStepChange={setCurrentStep}
        />
      )}
    </>
  );
};

export default CreateInvoiceHeader;
